import React from 'react';
import { Controller } from 'react-hook-form';

const Step4PreferredRetailer = ({ control, errors }) => {
console.log(errors)
  return (
    <div style={{
      maxWidth: '800px',
      width: '100%',
      background: '#fff',
      borderRadius: '10px',
      padding: '32px 36px',
    }}>
      <h5 style={{ fontWeight: '600', fontSize: '18px', marginBottom: '4px' }}>
        Preferred Retailer
      </h5>
      <p style={{ color: '#888', fontSize: '13px', marginBottom: '28px' }}>
        Define your preferred retailer for your brand
      </p>

      <Controller
        name="preferred_retailer"
        control={control}
        render={({ field }) => (
          <>
            <textarea {...field} className='form-control' rows={7} placeholder='Example : Premium retailer in Europe aligned with sustainable fashion' />
            {errors?.preferred_retailer?.message && <p style={{color: 'red', fontSize: '12px', marginTop: '4px'}}>{errors?.preferred_retailer?.message}</p>}
          </>
        )}
      />
    </div>
  );
};

export default Step4PreferredRetailer;
